export default __webpack_public_path__ + "static/media/goat.ec2f7bba.mp3";